<template>

	<div>
		<el-table :data="tableData" style="width: 100%" border stripe>
			<el-table-column prop="id" label="编号" width="50"></el-table-column>
      		<el-table-column prop="bussness" label="业务" width="180"></el-table-column>
      		<el-table-column prop="companyName" label="公司名称" width="120"></el-table-column>
      		<el-table-column prop="realName" label="真实姓名" width="160"></el-table-column>
      		<el-table-column prop="telephone" label="电话号码" width="160"></el-table-column>
      		<el-table-column prop="remark" label="备注" width="160"></el-table-column>
      		<el-table-column  label="状态" width="160">
      			<template scope="scope">
      				<el-tag v-if="scope.row.state==0" type="success">已处理</el-tag>
      				<el-tag  v-if="scope.row.state==1"  type="warning">未处理</el-tag>
      			</template> 
      		</el-table-column>
      		<el-table-column label="操作" width="250">
      			<template scope="scope">
					<el-button size="small" v-if="scope.row.state==1" @click="visibleJoinUs(scope.$index, scope.row)">标记为已处理</el-button>
				</template>
      		</el-table-column>
      	</el-table>
      	<el-pagination background ayout="prev, next" @current-change="handlerCurrentPage"  :page-size="pageSize" :total="total">
		</el-pagination>


		
	</div>

	
</template>
<script >
	import {getJoinUsList,visibleJoinUs} from "@/api/api"
	export default {
		data(){
		 	return {
		 		tableData:[],
		 		pageSize:15,
		 		total:0,
		 		pageCount:0
		 	}
		},
		created:function() {
			var _this = this;
			let params = {pageNum:0,pageSize:this.pageSize};
			getJoinUsList(params).then(res =>{
				this.tableData = res.data.data.list;
				this.total = res.data.data.total;
				this.pageCount=res.data.data.pages;
			});
			
		},
		methods:{
			handlerCurrentPage(currentPage){
				let params = {pageNum:currentPage,pageSize:this.pageSize};
				getJoinUsList(params).then(res =>{
					this.tableData = res.data.data.list;
					this.total = res.data.data.total;
					this.pageCount = res.data.data.pages;
				});
			},
			
			reload(){
				console.log("reload");
				let params = {pageNum:this.currentPage,pageSize:this.pageSize};
				getJoinUsList(params).then(res =>{
					this.tableData = res.data.data.list;
					this.total = res.data.data.total;
					this.pageCount = res.data.data.pages;
					this.currentPage = res.data.data.pageNum;
				});
			},
			visibleJoinUs(index,row){
				let _this = this;
				let params={id:row.id};
				if(row.state==1){
					params.state=0;
				}else{
					params.state=1;
				}
				visibleJoinUs(params).then(res=>{
					if(res.data.status=='success'){
						this.$message({
					            type: 'success',
					            message: '操作成功'
					         });
						_this.reload();
					}
				});
			}
		}
	}
</script>